import { render, staticRenderFns } from "./ViewOrderView.vue?vue&type=template&id=07a3b371"
import script from "./ViewOrderView.vue?vue&type=script&lang=js"
export * from "./ViewOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports